import type { S3RetentionStatus } from '../services/api';

/**
 * O ESTADO DO BUCKET NA AWS (12/10/2026, contrato da PR #405 do backend). Antes, `bucketExists: false` juntava bucket
 * inexistente, credencial vencida, falta de permissão, rede fora e bucket em outra região; a #460 passou a tratar tudo
 * isso como "não confirmado". Com a #405 o servidor separa:
 *   - `confirmado`: a AWS respondeu que o bucket existe;
 *   - `inexistente`: a AWS respondeu que NÃO existe (o único caso em que a tela pode afirmar isso);
 *   - `nao_confirmado`: não deu para saber, e `bucketCheckMotivo` diz por quê.
 * Backend sem a #405 (sem `bucketCheck`): `bucketExists:false` segue "não confirmado", como na #460.
 */
export type EstadoDoBucket = 'confirmado' | 'inexistente' | 'nao_confirmado';

export function estadoDoBucket(status: Pick<S3RetentionStatus, 'bucketExists' | 'bucketCheck'>): EstadoDoBucket {
  if (status.bucketCheck === 'confirmado' || status.bucketCheck === 'inexistente' || status.bucketCheck === 'nao_confirmado') {
    return status.bucketCheck;
  }
  return status.bucketExists ? 'confirmado' : 'nao_confirmado';
}

/** A frase do Aplicar travado, dita pelo que a AWS respondeu (ou não). */
export function fraseDoBucketTravado(estado: EstadoDoBucket, bucket: string, motivo?: string | null): string {
  if (estado === 'inexistente') {
    return `O bucket ${bucket} não existe na conta da AWS. Nada é aplicado até o cliente ter um bucket que exista.`;
  }
  return motivo
    ? `Não confirmei o bucket na AWS: ${motivo}. Nada é aplicado até o bucket ser confirmado.`
    : 'Não confirmei o bucket na AWS: ele não existe, ou a leitura da AWS falhou (o servidor ainda não distingue). Nada é aplicado até o bucket ser confirmado.';
}
